import FormRegistration from '@/components/formRegistration';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';

import { useAppDispatch, useAppSelector } from '@/hooks/hooks';
import { setError, setLoader } from '@/redux/rootReducer';
import { registerFormFields } from '@/helper/fields';
import { offLoadLang } from '@/helper/functions';
import { setLoad } from '@/redux/formsReducer';

import LoaderIcon from '@/components/UI/loader';
import Header from '@/components/header';
import HeadData from '@/components/headData';

import style from './registration.module.scss';

const Registration = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const loader = useAppSelector((state) => state.rootState.loader.language);

  const [initialValues, setInitialValues] = useState<any | null>(null);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const requestDomens = () => {
    dispatch(setError(false));
    dispatch(setLoader({ title: 'registration', status: false }));
  };

  useEffect(() => {
    document.body.style.overflow = 'auto';
    dispatch(setLoad(false));
    dispatch(setLoader({ title: 'registration', status: true }));

    setTimeout(() => {
      dispatch(setLoader({ title: 'registration', status: false }));
    }, 1000);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    loader && offLoadLang(dispatch);
  }, [dispatch, loader]);

  useEffect(() => {
    const values = sessionStorage.getItem('registration') as string;
    if (values) {
      setInitialValues({ ...JSON.parse(values) });
    } else {
      setInitialValues({
        login: '',
        password: '',
        confirmPassword: '',
        email: '',
      });
    }
  }, []);

  const renderLoader = () => loader && <LoaderIcon />;

  const renderForm = () =>
    initialValues && (
      <FormRegistration
        initialValues={initialValues}
        fields={registerFormFields}
        reload={requestDomens}
      />
    );

  const renderContent = () =>
    !loader && (
      <div className={style.registration}>
        <h1 className={style.registration_title}>
          {t('formRegistration.title')}
        </h1>
        {renderForm()}
      </div>
    );

  return (
    <section className={style.wrapper}>
      <HeadData title='formRegistration.title' />
      <Header register={true} />
      {renderLoader()}
      {renderContent()}
    </section>
  );
};

export default Registration;
